export enum LayoutOpenedFrom {
    LIST_LAUNCHER = "listLauncher",
    TOOLBOX = "toolbox"
}
